(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.administration');
    module.factory('ThirdPartyAppService', ['$http', 'SharedAgendaService', ThirdPartyAppServiceFn]);


    /* service for requesting third-party-apps */
    function ThirdPartyAppServiceFn($http, SharedAgendaService) {
        var baseUrl = '/api/thirdpartyapps/';

        var service = {
            query: query,
            getByUser: getByUser,
            update: update,
            save: save,
            deactivate: deactivate
        };

        return service;

        /* get all */
        function query(all) {
            return $http.get(baseUrl + (all ? all : false)).then(function (response) {
                return response.data;
            });
        }

        /* get by user */
        function getByUser() {
            return $http.get(baseUrl + 'user/' + SharedAgendaService.currentUser().id).then(function (response) {
                return response.data;
            });
        }

        /* delete */
        function deactivate(id) {
            return $http.delete(baseUrl + id).then(function (response) {
                return response.data;
            });
        }

        /* update */
        function update(id, item) {
            return $http.put(baseUrl + id, item).then(function (response) {
                return response.data;
            });
        }

        /* save */
        function save(item) {
            return $http.post(baseUrl, item).then(function (response) {
                return response.data;
            });
        }
    }
})();